module.exports = __webpack_public_path__ + "img/CM.a72fdb01.svg";